import { service } from '@ember/service';
import BaseEditionForm from 'parog-web/components/mici/base-edition-form';
import IbdDiskSurveyFilledJournalEvent from 'parog-web/models/ibd-disk-survey-filled-journal-event';
import type SemeiaSessionService from 'parog-web/services/session';
import MiciBaseEditionFormEditionForm from './base-edition-form/edition-form/index';

export default class MiciIbdDiskSurveyEditionForm extends MiciBaseEditionFormEditionForm {
  static override forcDisplayName = 'Questionnaire IBD-Disk';
  static override fullComponentId = 'mici/ibd-disk-survey-edition-form';
  static override journalEventClass = IbdDiskSurveyFilledJournalEvent;

  @service declare session: SemeiaSessionService;

  override get currentSections(): Array<string> {
    return IbdDiskSurveyFilledJournalEvent.sections;
  }

  override get forcDisplayName(): string {
    return this.session.medic ? 'Questionnaire IBD-Disk' : 'Qualité de vie';
  }

  override afterCompleted = () => {
    this.analytics.trackPatientMeasurement('ibd-disk-survey');
    if (this.args.afterCompleted) this.args.afterCompleted();
  };

  <template>
    <BaseEditionForm
      @changeset={{this.changeset}}
      @save={{this.onSave}}
      @currentSections={{this.currentSections}}
      @patient={{this.patient}}
    >
      <:title>
        Au cours des 7 derniers jours
      </:title>
    </BaseEditionForm>
  </template>
}
